<template>
  <svg
    class="quiz-icon"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="url(#qi-grad)"
    stroke-width="2.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <defs>
      <linearGradient id="qi-grad" x1="8" y1="56" x2="56" y2="8" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#a855f7" />
        <stop offset="0.55" stop-color="#c084fc" />
        <stop offset="1" stop-color="#60a5fa" />
      </linearGradient>
    </defs>

    <!-- Q1: energia -->
    <g v-if="name === 'bolt'">
      <path d="M35 6 L15 36 H28 L24 58 L49 26 H35 Z" />
    </g>
    <g v-else-if="name === 'people'">
      <circle cx="32" cy="21" r="7" />
      <path d="M20 49 c0-8.5 5-13.5 12-13.5 s12 5 12 13.5" />
      <circle cx="14.5" cy="26" r="5" />
      <path d="M5 48 c0.5-7 4-11 9.5-11.5" />
      <circle cx="49.5" cy="26" r="5" />
      <path d="M59 48 c-0.5-7 -4-11 -9.5-11.5" />
    </g>
    <g v-else-if="name === 'gem'">
      <path d="M20 10 H44 L56 25 L32 54 L8 25 Z" />
      <path d="M8 25 H56" />
      <path d="M20 10 L28 25 M44 10 L36 25 M28 25 L32 54 L36 25" />
    </g>
    <g v-else-if="name === 'infinity'">
      <path d="M14 32 c0-5 4-9 9-9 8 0 10 18 18 18 5 0 9-4 9-9 s-4-9-9-9 c-8 0-10 18-18 18 -5 0-9-4-9-9 z" />
    </g>
    <g v-else-if="name === 'eye'">
      <path d="M5 32 C15 17 49 17 59 32 C49 47 15 47 5 32 Z" />
      <circle cx="32" cy="32" r="7.5" />
      <circle cx="32" cy="32" r="2.2" fill="url(#qi-grad)" stroke="none" />
    </g>
    <g v-else-if="name === 'spiral'">
      <circle cx="32" cy="32" r="2.2" fill="url(#qi-grad)" stroke="none" />
      <path d="M32 32 C 38 29.5, 43 34, 42 40 C 40.5 47.5, 32 50, 25 46" />
      <path d="M32 32 C 26 34.5, 21 30, 22 24 C 23.5 16.5, 32 14, 39 18" />
      <path d="M45 15 C 52 20, 55 28, 53 37" stroke-width="1.6" opacity="0.65" />
      <path d="M19 49 C 12 44, 9 36, 11 27" stroke-width="1.6" opacity="0.65" />
    </g>

    <!-- Q2: muzica -->
    <g v-else-if="name === 'mic'">
      <rect x="25" y="7" width="14" height="26" rx="7" />
      <path d="M17 29 c0 10 6.5 17 15 17 s15-7 15-17" />
      <path d="M32 46 v9 M24 55 h16" />
    </g>
    <g v-else-if="name === 'sparkle'">
      <path d="M32 8 L35.5 28.5 L56 32 L35.5 35.5 L32 56 L28.5 35.5 L8 32 L28.5 28.5 Z" />
      <path d="M45 19 l4.5-4.5 M19 45 l-4.5 4.5 M45 45 l4.5 4.5 M19 19 l-4.5-4.5" stroke-width="2" />
    </g>
    <g v-else-if="name === 'vinyl'">
      <circle cx="32" cy="32" r="23" />
      <circle cx="32" cy="32" r="9" />
      <circle cx="32" cy="32" r="2.4" fill="url(#qi-grad)" stroke="none" />
      <path d="M32 15 a17 17 0 0 1 17 17 M32 49 a17 17 0 0 1 -17 -17" stroke-width="1.4" opacity="0.7" />
    </g>
    <g v-else-if="name === 'wave'">
      <path d="M6 32 h4 M14 27 v10 M20 22 v20 M26 14 v36 M32 8 v48 M38 16 v32 M44 23 v18 M50 28 v8 M54 32 h4" />
    </g>
    <g v-else-if="name === 'moon'">
      <path d="M41 8 a24 24 0 1 0 15 33 A19 19 0 1 1 41 8 Z" />
      <path d="M48 14 v6 M45 17 h6 M54 27 v4 M52 29 h4" stroke-width="2" />
    </g>

    <!-- Q3: la petrecere -->
    <g v-else-if="name === 'flame'">
      <path d="M32 7 c7 9 13 16 13 27 a13 13 0 0 1 -26 0 c0-6 2.5-10 6-15 1 4 3 6 5.5 7 C29 19 30 13 32 7 z" />
      <path d="M32 34 c3 3 5 5 5 9 a5 5 0 0 1 -10 0 c0-4 2-6 5-9 z" stroke-width="2" />
    </g>
    <g v-else-if="name === 'sun'">
      <circle cx="32" cy="32" r="10" />
      <path d="M32 6 v8 M32 50 v8 M6 32 h8 M50 32 h8 M13.6 13.6 l5.6 5.6 M44.8 44.8 l5.6 5.6 M50.4 13.6 l-5.6 5.6 M19.2 44.8 l-5.6 5.6" />
    </g>
    <g v-else-if="name === 'target'">
      <circle cx="32" cy="32" r="22" />
      <circle cx="32" cy="32" r="14" />
      <circle cx="32" cy="32" r="6" />
      <circle cx="32" cy="32" r="1.8" fill="url(#qi-grad)" stroke="none" />
    </g>
    <g v-else-if="name === 'crown'">
      <path d="M9 45 V20 L22 30 L32 13 L42 30 L55 20 V45 Z" />
      <path d="M13 52 h38" />
    </g>
    <g v-else-if="name === 'crystal'">
      <circle cx="32" cy="27" r="17" />
      <path d="M16 53 c4-4 9-6 16-6 s12 2 16 6" />
      <path d="M30 19 l1.5 5 5 1.5 -5 1.5 -1.5 5 -1.5-5 -5-1.5 5-1.5 z" stroke-width="2" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'QuizIcon',
  props: {
    name: { type: String, required: true },
  },
}
</script>

<style scoped>
.quiz-icon {
  display: block;
  filter: drop-shadow(0 0 7px rgba(168, 85, 247, 0.65));
}
</style>
